import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import gettext from '@sdk/lang/gettext';
import { FormLabel } from '@sdk/components/ui/modalForm/modalForm.styles';

import { ScrollContainer } from '@web/shiftTasks/ComposeTask/Subtasks/subtasks.styles';
import PlusIcon from '@web/assets/svg/Icons/16/note-add.svg';
import ChecklistIcon from '@web/assets/svg/UI/checklist.svg';
import { TaskTemplateAddButton } from '@web/shiftTasks/ComposeTask/composeTask.styles';
import { DraggableSubtask } from '@web/shiftTasks/ComposeTask/Subtasks/SubtasksField/DraggableSubtask/DraggableSubtask';

import { useSubtasksField } from './subtasksField.hooks';
import { SubtasksFieldContainer } from './subtasksField.styles';

export function SubtasksField() {
  const { append, fields, move, remove } = useSubtasksField();

  return (
    <DragDropContext
      onDragEnd={({ destination, source }) => {
        if (!destination || source.droppableId !== destination.droppableId) {
          return;
        }

        move(source.index, destination.index);
      }}>
      <FormLabel>
        {gettext('subtasks')} <ChecklistIcon aria-hidden={true} />
      </FormLabel>

      <SubtasksFieldContainer>
        <ScrollContainer>
          <Droppable droppableId="subtasks-droppable-area" isCombineEnabled={false}>
            {(dropProvided) => (
              <div {...dropProvided.droppableProps} ref={dropProvided.innerRef}>
                {fields.map((field, index) => (
                  <DraggableSubtask
                    formFieldId={field.id}
                    index={index}
                    key={field.id}
                    canRemove={fields.length > 1}
                    removeSubtask={remove}
                  />
                ))}
                {dropProvided.placeholder}
              </div>
            )}
          </Droppable>
        </ScrollContainer>
        <TaskTemplateAddButton
          onClick={(ev) => {
            append({ title: '', isNewRecord: true });
            ev.preventDefault();
          }}>
          <PlusIcon />
          {gettext('Add more')}
        </TaskTemplateAddButton>
      </SubtasksFieldContainer>
    </DragDropContext>
  );
}
